import { render, staticRenderFns } from "./gkXiangQing.vue?vue&type=template&id=d06682e4&scoped=true"
import script from "./gkXiangQing.vue?vue&type=script&lang=js"
export * from "./gkXiangQing.vue?vue&type=script&lang=js"
import style0 from "./gkXiangQing.vue?vue&type=style&index=0&id=d06682e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06682e4",
  null
  
)

export default component.exports